import { render } from "./addInvoiceModal.vue?vue&type=template&id=994569e8"
import script from "./addInvoiceModal.vue?vue&type=script&lang=js"
export * from "./addInvoiceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__